<template>
  <div class="searchList" :class="List.length > 3 ? '' : 'ht'">
    <div class="ty-top" v-for="index in List" :key="index.goodsId">
      <img :src="index.picUrl" class="list_img" @click="goDetails(index.goodsId)" />

      <p class="text1 van-ellipsis" @click="goDetails(index.goodsId)">{{index.goodsName}}</p>
      <div
        class="saleRati"
        v-if="index.children.length<2"
      >￥{{(index.children[0].salePrice/index.children[0].saleRatio).toFixed(2) }}/{{index.children[0].goodsUnitLabel}}</div>
      <!-- 多规格 -->
      <van-row
        type="flex"
        justify="space-between" 
        v-if="index.children.length>1"
        class="standard"
        :class="index.children.length>1 ? 'standard_dd' : ''"
      >
        <van-col
          span="15"
          :data-com="goodsKusCom(index.children)"
          class="goodsKusCom"
        >{{goodsKusCom(index.children)}}</van-col>
        <van-col span="7">
          <van-button
            type="primary"
            size="mini"
            round
            color="#74B42B"
            @click="choseGoodsSku(index.goodsId)"
          >选规格</van-button>
        </van-col>
      </van-row>
      <!-- 规格列表 -->
      <div v-if="index.children.length>1 && index.showGuiGe" class="list-sku">
        <div v-for="i in index.children" :key="i.skuId">
          <van-row
            type="flex"
            justify="space-between"
            class="saleRati"
            style="margin:3px 0 0 0"
          >￥{{i.salePrice/i.saleRatio | numFilter}}/{{i.goodsUnitLabel}}</van-row>
          <van-row type="flex" justify="space-between" class="list-sku-row">
            <van-col span="13" class="goodsKusCom">
              ￥{{i.salePrice}}/{{i.saleUnitLabel}}
              <span
                v-if="i.saleRatio != 1 || i.goodsUnitLabel != i.saleUnitLabel"
              >({{i.saleRatio}}{{i.goodsUnitLabel}})</span>
            </van-col>
            <van-col span="3" v-if="!i.havingCartInfo">
              <!-- 添加按钮 -->
              <van-icon name="add" size="20px" color="#74B42B" @click="showNumS(i,index.goodsId)" />
            </van-col>
            <!-- 规格计步器 -->
            <van-col span="10" v-if="i.havingCartInfo">
              <van-stepper
                style="width:75px;height:20px"
                class="stepper"
                button-size="16px"
                input-width="20px"
                async-change
                min="0"
                @overlimit="removeAllGoods(i,index.goodsId)"
                @minus="removeGoods(i,index.goodsId)"
                @plus="addGoods(i,index.goodsId)"
                @focus="writeOty(i,index.goodsId)"
                v-model="i.orderQty"
              />
            </van-col>
            <!-- 弹框输入商品数量 -->
            <van-dialog
              v-model="i.showDia"
              title="修改商品数量"
              show-cancel-button
              confirmButtonColor="rgba(116, 180, 43, 1)"
              @confirm="changgeGoodsNum(i,index.goodsId)"
            >
              <input type="text" v-model="i.newOrderQty" class="changeInput" />
            </van-dialog>
          </van-row>

          <van-row type="flex" justify="space-between" class="list-sku-row">
            <!-- 备注 -->
            <div
              class="remark"
              v-show="i.havingCartInfo"
              @click="showPopi(i,index.goodsId)"
            >备注：{{i.remark}}</div>
            <!-- 备注框 -->
            <van-dialog
              v-model="i.showPop"
              confirmButtonColor="rgba(116, 180, 43, 1)"
              show-cancel-button
              @confirm="write(i,index.goodsId)"
            >
              <van-cell-group>
                <van-field
                  v-model="i.newRemark"
                  rows="1"
                  autosize
                  type="textarea"
                  maxlength="50"
                  placeholder="请输入备注"
                  show-word-limit
                />
              </van-cell-group> 
            </van-dialog>
          </van-row> 
        </div>
      </div>
      <!-- 单规格 -->
      <div v-if="index.children.length<2">
        <van-row type="flex" justify="space-between" class="standard">
          <van-col span="12" class="goodsKusCom">
            ￥{{index.children[0].salePrice}}/{{index.children[0].saleUnitLabel}}
            <span
              v-if="index.children[0].saleRatio != 1 || index.children[0].goodsUnitLabel != index.children[0].saleUnitLabel"
            >({{index.children[0].saleRatio}}{{index.children[0].goodsUnitLabel}})</span>
          </van-col>
          <van-col span="2">
            <!-- 添加按钮 -->
            <van-icon
              name="add"
              size="20px"
              color="#74B42B"
              @click="showNum(index)"
              v-if="!index.children[0].havingCartInfo"
            />
          </van-col>
          <!-- 计步器 -->
          <van-col span="10" v-if="index.children[0].havingCartInfo">
            <van-stepper
              class="stepper"
              button-size="18px"
              input-width="28px"
              async-change
              min="0"
              v-model="index.children[0].orderQty"
              @overlimit="removeAllGoodsDan(index)"
              @minus="removeGoodsD(index)"
              @plus="addGoodsD(index)"
              @focus="changgeGoods(index)"
            />
          </van-col>
        </van-row>
        <div
          class="remark van-ellipsis"
          v-show="index.children[0].havingCartInfo"
          @click="showPopDan(index.children[0],index.goodsId)"
        >备注：{{index.children[0].remark}}</div>
      </div>
      <!-- 备注框 -->
      <van-dialog
        v-model="index.children[0].showPop"
        show-cancel-button
        confirmButtonColor="rgba(116, 180, 43, 1)"
        @confirm="write(index.children[0],index.goodsId)"
      >
        <van-cell-group>
          <van-field
            v-model="index.children[0].newRemark"
            rows="1"
            autosize
            type="textarea"
            maxlength="50"
            placeholder="请输入备注"
            show-word-limit
          />
        </van-cell-group>
      </van-dialog>
      <!-- 单规格修改商品数量 -->
      <van-dialog
        v-model="index.children[0].showDia"
        title="修改商品数量"
        show-cancel-button
        confirmButtonColor="rgba(116, 180, 43, 1)"
        @confirm="changgeGoodsNumDan(index)"
      >
        <input type="text" v-model="index.children[0].newOrderQty" class="changeInput" />
      </van-dialog>
    </div>
  </div>
</template>

<script>
export default {
  props: ["List"],
  created() {
    this.listSkuDiv = false;
    // 获取id
    this.customerId = localStorage.getItem("customerId");
    // 获取购物车数量
    this.getCount();
  },
  computed: {
    // 显示区间范围
    goodsKusCom() {
      return goods => {
        let arr = [];
        goods.map(v => {
          if (v.salePrice != null && v.saleRatio != null) {
            arr.push((v.salePrice / v.saleRatio).toFixed(2));
          }
        });
        arr.sort((a, b) => {
          return a - b;
        });
        arr = arr.map(v => {
          return "￥" + v + "/" + goods[0].goodsUnitLabel;
        });
        return arr[0] + "-" + arr[arr.length - 1];
      };
    },
    // 点击显示备注框
    showRemark() {
      return id => this.showRemarkId === id;
    }
  },
  data() {
    return {
      customerId: "",
      showRemarkId: "",
      showPopup: false,
      remark: "",
      goodNum: 1,
      showDia: false,
      GoodsDto: {},
      count: 0,
      todo: [],
      skuId: ""
    };
  },
  methods: {
    // 添加单分类商品
    showNum(Goods) {
      this.$emit("DanAdd", Goods.children[0].skuId, Goods.children[0].goodsId);
      this.addGood(Goods.children[0]);
    },
    // 添加单分类商品
    addGoodsD(Goods) {
      this.addGood(Goods.children[0]);
    },
    // 移除单分类
    removeGoodsD(Goods) {
      if (Goods.children[0].orderQty == 0) {
        this.removeAllGoods(Goods.children[0], Goods.children[0].goodsId);
      }
      this.addGood(Goods.children[0]);
    },
    // 添加多规格分类商品
    showNumS(i, goodsId) {
      // this.skuId = i.skuId;
      this.$emit("JiBu", i.skuId, goodsId);
      this.addGood(i, 1);
    },
    // 输入多规格数量
    writeOty(i, goodsId) {
      this.$emit("Dia", i.skuId, goodsId);
    },
    // 输入单规格
    changgeGoodsNumDan(Goods) {
      if (Goods.children[0].newOrderQty <= 0) {
        return this.$toast("数量必须大于0");
      }
      Goods.children[0].orderQty = Goods.children[0].newOrderQty;
      this.addGood(Goods.children[0]);
    },
    // 添加商品方法
    addGood(Goods, state) {
      this.GoodsDto = { ...Goods, customerId: this.customerId };
      if (state == 1) {
        this.GoodsDto.orderQty = 1;
      }
      this.$axios.post("/trade/tradeCart/save", this.GoodsDto).then(res => {
        if (res.data.code != 0) {
          return;
        }
        // this.getCount();
      });
    },
    // 删除所有多规格商品
    async removeAllGoods(Goods, goodsId) {
      this.$emit("removeAll", Goods.skuId, goodsId);
      this.addGood(Goods);
    },
    // 删除所有单规格商品
    removeAllGoodsDan(Goods) {
      this.$emit(
        "DanAllRem",
        Goods.children[0].skuId,
        Goods.children[0].goodsId
      );
      this.addGood(Goods.children[0]);
    },
    // 删除商品
    removeGoods(Goods, goodsId) {
      if (Goods.orderQty == 0) {
        this.removeAllGoods(Goods, goodsId);
      }
      this.addGood(Goods);
    },
    // 添加商品
    addGoods(Goods, goodsId) {
      this.$emit("addition", Goods.skuId, goodsId);
      this.addGood(Goods);
    },
    // 修改单商品
    changgeGoods(Goods) {
      this.$emit("DiaDan", Goods.children[0].skuId, Goods.children[0].goodsId);
    },
    // 多状态输入数量确认
    changgeGoodsNum(Goods) {
      if (Goods.newOrderQty <= 0) {
        return this.$toast("数量必须大于0");
      }
      Goods.orderQty = Goods.newOrderQty;
      this.addGood(Goods);
    },
    // 多状态备注框
    showPopi(Goods, goodsId) {
      this.$emit("sPop", Goods.skuId, goodsId);
    },
    // 单规格显示备注框
    showPopDan(Goods, goodsId) {
      this.$emit("sPopDan", Goods.skuId, goodsId);
    },
    // 获取购物车总数
    getCount() {
      this.$axios
        .get(`/trade/tradeCart/count?customerId=${this.customerId}`)
        .then(res => {
          this.count = res.data.data;
          this.$emit("count", this.count);
        });
    },
    // 点击选规格按钮
    choseGoodsSku(id) {
      this.$emit("Guige", id);
    },
    // 去商品详情页
    goDetails(id) {
      this.$router.push({ path: "/details", query: { goodsId: id } });
    },
    // 输入单层备注
    write(i) {
      i.remark = i.newRemark;
      this.addGood(i);
    },
    // 输入多层备注
    writeS() {

    }
  }
};
</script>

<style lang='scss' scoped>
.searchList {
  margin: 0 auto;
}
.ty-top {
  margin-left: 0px;
  position: relative;
}
.ht {
  height: 1200px !important;
}
van-checkbox {
  width: 80px;
  background-color: red;
  border: 1px solid rgba(153, 153, 153, 1);
}
.cart-btn {
  background: linear-gradient(
    135deg,
    rgba(172, 219, 86, 1) 0%,
    rgba(116, 180, 43, 1) 100%
  );
  border-radius: 16px;
  border: 0px;
  top: -5px;
}
.ty-top {
  width: 89%;
  background-color: #fff;
  margin: 6px auto;
  border-radius: 10px;
  padding: 6px 10px 6px 8px;
  box-shadow: 0px 0px 4px 1px rgba(153, 153, 153, 0.1);
  font-size: 12px;
  overflow: hidden;
}
.sign {
  position: absolute;
  padding-left: 20px;
  box-sizing: border-box;
  right: 0;
  width: 90px;
  height: 24px;
  line-height: 24px;
  background: linear-gradient(
    90deg,
    rgba(116, 180, 43, 0) 0%,
    rgba(116, 180, 43, 0.5) 22%,
    rgba(116, 180, 43, 1) 100%
  );
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  border-radius: 2px;
}
.place1 {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 17px;
}
.place2 {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
}
.line {
  width: 100%;
  height: 1px;
  background-color: #dddddd;
  margin: 5px 0;
}
img {
  float: left;
  width: 70px;
  height: 95px;
  background: rgba(247, 247, 247, 1);
  border-radius: 2px;
}
.text1 {
  white-space: normal !important;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
  display: -webkit-box;
  overflow: hidden;
  white-space: normal !important;
  text-overflow: ellipsis;
  word-wrap: break-word;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.remark {
  margin-top: 50px;
  width: 95%;
  margin: 3px auto;
  background: rgba(102, 102, 102, 0.05);
  border-radius: 8px;
  font-size: 10px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 20px;
  padding-left: 10px;
}
.stepper {
  position: relative;
  border-radius: 20px;
  border: 1px solid rgba(116, 180, 43, 1);
}
.stepper /deep/  button {
  background-color: #fff;
  border-radius: 50%;
  color: rgba(116, 180, 43, 1);
}
.stepper /deep/ input {
  background-color: #fff;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
}
.noList {
  width: 100%;
  height: 200px;
  margin-top: 100px;
}
.search-p {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 20px;
  text-align: center;
}
.changeInput {
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  width: 20%;
  box-sizing: border-box;
  padding: 2px;
  border: 1px solid rgba(151, 151, 151, 1);
  margin: 15px 40%;
}
.cart {
  padding-bottom: 100px;
  background: rgba(242, 242, 242, 1);
}
van-checkbox {
  width: 80px;
  background-color: red;
  border: 1px solid rgba(153, 153, 153, 1);
}
.cart-btn {
  background: linear-gradient(
    135deg,
    rgba(172, 219, 86, 1) 0%,
    rgba(116, 180, 43, 1) 100%
  );
  border-radius: 16px;
  border: 0px;
  top: -5px;
}
.goodsKusCom {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 166, 35, 1);
  line-height: 22px;
}
.standard_dd {
  margin-top: 53px;
}
.list-sku {
  margin-top: 10px;
  padding-left: 83px;
  box-sizing: border-box;
}
.list_img {
  width: 80px;
  height: 88px;
  margin: 0 3px 5px 0;
  border-radius: 5px;
  vertical-align: middle;
  object-fit: cover;
}
.searchList >>> .van-stepper__plus {
  position: absolute;
  right: 5% !important;
}
.searchList >>> .van-stepper__input {
  width: 40% !important;
}
.stepper >>> .van-stepper__input {
  -moz-appearance: textfield;
}

.searchList >>> .van-stepper__minus--disabled,
.searchList >>> .van-stepper__minus {
  left: 5% !important;
}
.saleRati {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 17px;
  margin-top: 38px;
}
.van-col--10 {
  float: right;
  display: flex;
  justify-content: flex-end;
}
.van-col--7 { 
  text-align: right;
}
</style>